module.exports = __webpack_public_path__ + "static/media/splash.8544bc90.png";